import { Component, Vue } from "vue-property-decorator";
import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";
import { ValidationChecker } from "./lib/validation";
import router from "@/router";
import { Auth } from "aws-amplify";

@Component({
  created() {
    this.$parent.$children[0].$data.headerElement = false;
  },
})
export default class Reminder extends Vue {
  public reminderInfoArea: boolean = true;
  public resetPasswordArea: boolean = false;
  public user: string = "";
  public verificationCode: string = "";
  public newPassword: string = "";
  public cognitoUser: CognitoUser;
  public error: string = "";

  /**
   * SignInページに戻る
   */
  public backLoginPage() {
    localStorage.clear();
    return router.push("/signIn");
  }

  /**
   * パスワードリセットするための検証コードを取得
   */
  public passwordReminder() {
    const self = this;
    Auth.forgotPassword(self.user).then(() => {
      alert(this.$t("message.verificationCodeIsSent"));
      self.reminderInfoArea = false;
      self.resetPasswordArea = true;
    }).catch((err: any) => {
      console.error(err);
    });
  }

  /**
   * パスワードリセットを実行
   */
  public resetPassword() {
    const self = this;
    if (!ValidationChecker.checkAllValidation(this)) {
      return;
    }
    Auth.forgotPasswordSubmit(
      self.user,
      self.verificationCode,
      self.newPassword,
    ).then(() => {
      console.log("password reset succeeded!");
      localStorage.clear();
      alert(this.$t("message.passwordIsReset"));
      return router.push("/signIn");
    }).catch((err: any) => {
      console.error(err);
      alert(this.$t("message.failedToResetPassword"));
    });
  }
}
